import { render, staticRenderFns } from "./stuBasicManager.vue?vue&type=template&id=8d7b2746"
import script from "./stuBasicManager.vue?vue&type=script&lang=js"
export * from "./stuBasicManager.vue?vue&type=script&lang=js"
import style0 from "./stuBasicManager.vue?vue&type=style&index=0&id=8d7b2746&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports